export default "__VITE_ASSET__DGlJkPEX__"